const PRODUCTION_DOMAIN = 'https://appbuilder.8base.com';
const STAGING_DOMAIN = 'https://appbuilder-staging.8basedev.com';
export const isProductionStand = () => {
    return window.location.origin === PRODUCTION_DOMAIN;
};
export const isStagingStand = () => {
    return window.location.origin === STAGING_DOMAIN;
};
